export default "__VITE_ASSET__C5B0aDEI__"